import React from "react"
import {Link} from "react-router-dom"

import {BackofficePage} from "components/backoffice/Layout/BackofficePage"
import {
  URL_BACKOFFICE_MEDIA_SHOW_ADD,
  URL_BACKOFFICE_STORAGE_INGESTION_INBOX,
  URL_BACKOFFICE_STORAGE_PROVIDER_LIST,
  URL_BACKOFFICE_TRANSCODE_IMPORT_LIST,
  URL_BACKOFFICE_USER_LIST,
} from "static/constant/url"

const shortcuts = [
  {title: "Imports", description: "Suivre la file de transcodage", icon: "fa-wave-square", url: URL_BACKOFFICE_TRANSCODE_IMPORT_LIST, tone: "red"},
  {title: "Inbox média", description: "Valider les fichiers détectés", icon: "fa-inbox", url: URL_BACKOFFICE_STORAGE_INGESTION_INBOX, tone: "orange"},
  {title: "Catalogue", description: "Ajouter séries, films et épisodes", icon: "fa-photo-video", url: URL_BACKOFFICE_MEDIA_SHOW_ADD, tone: "purple"},
  {title: "Stockage", description: "Configurer les providers", icon: "fa-server", url: URL_BACKOFFICE_STORAGE_PROVIDER_LIST, tone: "green"},
  {title: "Utilisateurs", description: "Gérer les accès administrateurs", icon: "fa-users", url: URL_BACKOFFICE_USER_LIST, tone: "blue"},
]

export const DefaultRoute = () => {
  return <BackofficePage
    className="backoffice-home"
    eyebrow="Console d'administration"
    title="Pilotez Zipflix"
    description="Tous les outils de gestion du catalogue et de la diffusion, réunis au même endroit."
    icon="fa-th-large"
  >
    <section className="bo-shortcut-grid" aria-label="Accès rapides">
      {shortcuts.map(shortcut => <Link className={`bo-shortcut-card shortcut-${shortcut.tone}`} to={shortcut.url} key={shortcut.title}>
        <span className={`shortcut-icon fas ${shortcut.icon}`} aria-hidden="true"></span>
        <span className="shortcut-copy"><strong>{shortcut.title}</strong><small>{shortcut.description}</small></span>
        <span className="fas fa-arrow-right" aria-hidden="true"></span>
      </Link>)}
    </section>
  </BackofficePage>
}
